module.exports = __webpack_public_path__ + "img/home_bg1.010b8601.jpg";